const m = require('minthril');
const { component } = require('../../component');
const { Breadcrumbs } = require('../../components/breadcrumbs');

const McpDocsPage = component(() => ({
  view: () => m('article.panel.docs-page', [
    m(Breadcrumbs, {
      items: [
        { label: 'Docs', href: '/docs' },
        { label: 'Use Spache with an AI agent' }
      ]
    }),
    m('h2', 'Use Spache with an AI agent'),
    m('p', 'Connect Spache’s remote MCP server to an MCP-compatible coding agent. Once connected, you can ask the agent to inspect your sites, review route activity, and make approved changes using ordinary instructions.'),
    m('h3', 'Connect the Spache MCP server'),
    m('ol', [
      m('li', 'In your AI client, add a remote MCP server.'),
      m('li', [
        'Use this server URL: ',
        m('code', 'https://spache.online/mcp')
      ]),
      m('li', 'Connect. Spache will open a sign-in and authorization page in your browser.'),
      m('li', 'Sign in to Spache and approve the requested access. Review the permissions before accepting.')
    ]),
    m('p', [
      'The exact setup controls vary by AI client. Choose its ',
      m('em', 'remote MCP server'),
      ' option rather than configuring a local command or installing a package.'
    ]),
    m('h3', 'What you can ask it to do'),
    m('ul', [
      m('li', '“List my Spache sites and show me their preview URLs.”'),
      m('li', '“Show the last 7 days of traffic and render stats for my Mid Engine site.”'),
      m('li', '“List my most-requested routes and show any recent render failures for /products/widget.”'),
      m('li', '“Change this site’s cache lifetime to one hour.”'),
      m('li', '“Clear only the cache for /products/widget.”')
    ]),
    m('h3', 'Available capabilities'),
    m('ul', [
      m('li', [m('code', 'list_sites'), ' and ', m('code', 'get_site'), ' show your sites, preview URLs, and supported settings.']),
      m('li', [m('code', 'get_site_stats'), ' and ', m('code', 'list_routes'), ' report recent usage and route activity (up to 30 days).']),
      m('li', [m('code', 'get_route_failures'), ' inspects recent recorded failures for a route.']),
      m('li', [m('code', 'connect_site'), ' creates a Spache configuration for an already-deployed public SPA; it does not deploy your application or connect a custom domain.']),
      m('li', [m('code', 'update_site_settings'), ' can change the origin, cache lifetime, render waits, ignored routes, and request capture rules.']),
      m('li', [m('code', 'clear_site_cache'), ' and ', m('code', 'clear_route_cache'), ' invalidate cached content.']),
      m('li', [m('code', 'create_cache_webhook'), ' creates a deployment/content invalidation URL.'])
    ]),
    m('h3', 'Permissions and safety'),
    m('p', 'Reading site information requires read access. Connecting sites, changing settings, clearing caches, and creating webhooks require write access. The agent can only access sites in the Spache account you authorize.'),
    m('p', 'Ask the agent to inspect settings before changing them, and be explicit about the site and route you mean. Cache clears make the next request fetch fresh content and can trigger a render. A cache webhook URL is secret; creating a replacement invalidates the previous URL, so only ask for one when you intend to create or rotate it.'),
    m('p', [
      'You can review or disconnect connected agents under ',
      m('strong', 'Account → Developer access'),
      '.'
    ])
  ])
}));

module.exports = { McpDocsPage };
